(function () {
  angular.module('MktzapApp.Controllers')
    .controller('CountryController', countryController);

  countryController.$inject = ['FoundationApi', 'NotificationService', 'CountryService']

  function countryController (FoundationApi, NotificationService, CountryService) {
    var vm = this
    vm.countries = {}
    vm.totalCountries = 0
    vm.country = {}
    vm.countryEdit = {}

    getCountries()

    function getCountries () {
      CountryService
        .getCountries()
        .$promise
        .then(function (data) {
          if (data.countries) {
            vm.countries = data.countries
            vm.totalCountries = data.countries.length
          } else {
            NotificationService.errorHandler(data, 'Erro ao carregar países!')
            vm.totalCountries = 0
          }
        }).catch(function (data) {
          NotificationService.errorHandler(data, 'Erro durante a comunicação com banco de dados!')
          vm.totalCountries = 0
        })
    }

    vm.saveCountry = function (data) {
      if (!vm.country.name || !vm.country.initials || !vm.country.ddi || !vm.country.mask) {
        NotificationService.errorHandler(data, 'Todos os campos são obrigatórios!')
      } else {
        CountryService
          .store(vm.country)
          .$promise
          .then(function (data) {
            getCountries();
            vm.country = {};
            NotificationService.successHandler(data, 'Cadastrado com sucesso')
          })
          .catch(function (data) {
            NotificationService.errorHandler(data, 'Erro na execução!')
          })
      }
    }

    vm.update = function (payload, data) {
      if (!vm.countryEdit.name || !vm.countryEdit.initials || !vm.countryEdit.ddi || !vm.countryEdit.mask) {
        NotificationService.errorHandler(data, 'Todos os campos são obrigatórios!')
      } else {
        CountryService
          .update(payload)
          .$promise
          .then(function (data) {
            getCountries();
            if (data.success) {
              NotificationService.successHandler(data, 'Operação realizada com sucesso!')
              FoundationApi.publish('modal', 'close')
            }
          }).catch(function (data) {
            NotificationService.errorHandler(data, 'Erro ao salvar!')
          })
      }
    }

    vm.deleteCountryModal = function (countries) {
      vm.newCountry = countries
      FoundationApi.publish('deleteCountryModal', 'open')
    }

    vm.delete = function (payload) {
      CountryService
        .delete(payload)
        .$promise
        .then(function (data) {
          getCountries()
          if (data.success) {
            NotificationService.successHandler(data, 'Operação realizada com sucesso')
          }
        }).catch(function (data) {
          NotificationService.errorHandler(data, 'Erro ao deletar!')
        })
      FoundationApi.publish('deleteCountryModal', 'close')
    }

    vm.edit = function (countries) {
      vm.countryEdit = angular.copy(countries)
      FoundationApi.publish('modal', 'open')
    }
  }
})();
